export default "__VITE_ASSET__CZws29eb__"